import { render, staticRenderFns } from "./ImgAttributeEditorComponent.vue?vue&type=template&id=0a1a424c&scoped=true"
import script from "./ImgAttributeEditorComponent.vue?vue&type=script&lang=js"
export * from "./ImgAttributeEditorComponent.vue?vue&type=script&lang=js"
import style0 from "./ImgAttributeEditorComponent.vue?vue&type=style&index=0&id=0a1a424c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1a424c",
  null
  
)

export default component.exports